import { useKeycloak } from "@react-keycloak/web";
import React, { useContext, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import * as _api from "../../Apis/Documents_apis";
import { userContext } from "../../Stores/Store";

const DocumentsFolderAdd = (props) => {
  const handleClose = () => props.show(false);
  const { keycloak, initialized } = useKeycloak();
  const [errorForm, setErrorForm] = useState();
  const [folder, setFolder] = useState({
    name: "",
  });
  const user = useContext(userContext);

  const handleChange = (e) => {
    setFolder({ ...folder, [e.target.name]: e.target.value });
  };

  const addFolder = () => {
    _api
      .putDocumentFolder(
        keycloak.token,
        user.competitionid,
        user.skillid,
        folder
      )
      .then((results) => {
        if (results) {
          props.maj(results, "addFolder"); //on renvoie le résultat vers le state à modifier du parent
          props.show(false);
        } else {
          setErrorForm("Une erreur technique s'est produite");
        }
      });
  };

  return (
    <Modal
      className="modal_app"
      show={props.show}
      onHide={handleClose}
      backdrop="static"
      centered="true"
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Créer un dossier</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={(e) => e.preventDefault()}>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Control
                  placeholder="Nom du dossier"
                  name="name"
                  value={folder.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={() => addFolder()}>Ajouter</Button>
        <Button variant="secondary" onClick={handleClose}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DocumentsFolderAdd;
